import { LogoAppBar } from 'components/shared/appbar/logo'
import MainSidebarContent from 'components/shared/main-sidebar'
import * as React from 'react'

import SideBarLayout from '../sidebar-layout'

const HomeLayout = ({ children }: { children: JSX.Element }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState<boolean>(false)
    return (
        <SideBarLayout
            setMobileMenuOpen={setMobileMenuOpen}
            openMobileMenu={mobileMenuOpen}
            navbar={<LogoAppBar open={mobileMenuOpen} handleMenu={() => setMobileMenuOpen(!mobileMenuOpen)} />}
            sidebarContent={<MainSidebarContent />}>
            {children}
        </SideBarLayout>
    )
}

export default HomeLayout
